import axios from './api';

const API_URL = '/events/';

const createEvenement = async (userData) => {
  const response = await axios.post(API_URL,userData);
  return response.data;
};


const getEvenementById = async (id) => {
  const response = await axios.get(API_URL + id);
  return response.data;
};

const getAllEvenement = async() => {
  const response = await axios.get(API_URL);
  return response.data;
};

const DeleteEvenement = async (id) => {
  const response = await axios.delete(API_URL + id);
  return response.data;
};

const updateEvenement = async (id,data) => {
  const response = await axios.patch(API_URL+id,data);
  return response.data;
};

const updateThumbnail = async (id,data) => {
  const response = await axios.post(API_URL+id+'/thumbnail',data);
  return response.data;
};

const EventService = {
  getAllEvenement,
  createEvenement,
  getEvenementById,
  DeleteEvenement,
  updateEvenement,
  updateThumbnail
};

export default EventService;
